export const SPONSORED_CTA_DATA_TEST = 'watch-ad-button'
export const SUBSCRIBE_CTA_DATA_TEST = 'subscribe-button'
export const CREATE_A_FREE_ACCOUNT_DATA_TEST = 'create-a-free-account'
